import { Input } from '../../ui/input';
import FieldError from '../FieldError';
import { formatPhone } from '../intakeConstants';

export default function DriverStep({ formData, errors, handleChange }) {
  return (
    <div>
      <label className="text-blue-500 text-2xl font-bold mb-6 block">Driver</label>
      <div className="space-y-6">
        <div>
          <Input
            type="text"
            placeholder="Name"
            value={formData.driverName}
            onChange={(e) => handleChange('driverName', e.target.value)}
            className={`w-full bg-white h-16 text-lg placeholder:text-gray-400 placeholder:italic ${
              errors.driverName ? 'border-red-500' : ''
            }`}
          />
          <FieldError message={errors.driverName} />
        </div>
        <div>
          <Input
            type="tel"
            placeholder="Phone # (XXX) XXX-XXXX"
            value={formData.driverPhone}
            onChange={(e) => handleChange('driverPhone', formatPhone(e.target.value))}
            className={`w-full bg-white h-16 text-lg placeholder:text-gray-400 placeholder:italic ${
              errors.driverPhone ? 'border-red-500' : ''
            }`}
          />
          <FieldError message={errors.driverPhone} />
        </div>
      </div>
    </div>
  );
}
